export function scrollDisable() {
    var $body = $('body');
    var scrollTop;
    scrollTop = $(window).scrollTop();
    $body.addClass('scroll-disabled').css({top: -1 * scrollTop});
}

export function scrollEnable() {
    var $body = $('body');
    var scrollTop;
    $body.removeClass('scroll-disabled').css('top', 'auto');
    $(window).scrollTop(scrollTop);
}

export function headerOpacityScroll() {
    var top = $(window).scrollTop();
    var pageHeaderBg = $('#pageHeaderBgJS');
    var bgOpacity = 0.95;

    if (top > 190) {
        bgOpacity = 0.95;
    } else {
        bgOpacity = top * 5 / 1000;
    }

    pageHeaderBg.css('opacity', bgOpacity);
}

export function hideCaptions() {
    var scrollTop = $(window).scrollTop();
    var rubricNav = $('#rubricNav');
    var heading = $('.section-heading-wrapper').find('h2');
    var opacityNav = 1;
    var opacityHeading = 0;
    if (scrollTop < 150) {
        rubricNav.css('display', 'block');
        opacityNav = (1 - (scrollTop * 8 / 1000));
    } else {
        opacityNav = 0;
        rubricNav.css('display', 'none');
    }
    if (scrollTop < 250) {
        opacityHeading = (scrollTop - 125) * 7 / 1000;
    } else {
        opacityHeading = 1;
    }
    rubricNav.css('opacity', opacityNav);
    heading.css('opacity', opacityHeading);
}

export function scrollToAnchor() {
    var $page = $('html, body');
    $('#rubricNav').find('a[href*="#"]').click(function() {
        $page.animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 114
        }, 500);
        return false;
    });
}

export function setDataID(selector, attr) {
    var slidesArr = document.querySelectorAll(selector);
    for (let i = 0; i < slidesArr.length; i++) {
        slidesArr[i].setAttribute(attr, i);
    }
}

/* Function that centered swiper navigation arrows ********************************************************************/
export function navPos() {
    setTimeout(()=>{
        try{
            var teaserHeight = $('.swiper-slide-active').find('.content-item__teaser').height();
            var topPos = $('.swiper-slide-active').find('.content-item__teaser').offset().top + (teaserHeight /2);
            $('#swiperNextBtn').css('top', topPos + 'px').css('opacity', 1);
            $('#swiperPrevBtn').css('top', topPos + 'px').css('opacity', 1);
        } catch (e) {
            let err = e;
        }
    },100)
}

/* Set slide background function **************************************************************************************/
export function setPageBg(swiperClass) {
    var activeIndex = swiperClass.swiper.activeIndex;
    var slideBg = $('.swiper-slide[data-slide-id="' + activeIndex + '"]').find('.slide-bg').children('img').attr('src');
    $('.page-bg').animate({
        opacity: 0.2,
    }, 100, function () {
        $('.page-bg').css('background-image', 'url("' + slideBg + '")').animate({opacity: 1}, 100);
    });
}

/* Set prev and next teasers ******************************************************************************************/
export function setPrevNextTeasers() {
    let slidesArr = document.querySelectorAll('.content-item__teaser');
    for (let i = 0; i < slidesArr.length; i++) {
        if (i > 0) {
            let prevPoster = slidesArr[ i - 1 ].querySelector('.content-item__teaser img').cloneNode(true);
            slidesArr[i].querySelector('.prev-slide').innerHTML = prevPoster.outerHTML;
        }
        if (i+1 < slidesArr.length) {
            let nextPoster = slidesArr[ i + 1 ].querySelector('.content-item__teaser img').cloneNode(true);
            slidesArr[i].querySelector('.next-slide').innerHTML = nextPoster.outerHTML;
        }
    }
}


/* Init content info swiper *******************************************************************************************/